/** Pestañas del detalle de ficha; la ruta las valida como parámetro `tab`. */
export const VALORES_PESTANA_FICHA = [
  'definicion',
  'indicaciones',
  'estudios',
  'ets',
  'costo-efectividad',
  'guias',
  'referencias',
  'siglas',
] as const;

export type PestanaFicha = (typeof VALORES_PESTANA_FICHA)[number];
